<!-- loader -->
@if (isLoading$ | async) {
  <div class="flex justify-center items-center w-full h-full">
    <mat-progress-spinner
      mode="indeterminate"
      [strokeWidth]="5"
      [diameter]="50"
    ></mat-progress-spinner>
  </div>
}

<!-- content -->
@else {
  <div
    [class.pb-[30px]]="(publishingBannerCollapsed$ | async) === false"
    class="flex flex-col w-full h-full justify-start pl-8 transition-[padding] duration-300 app-publishing-container"
  >
    <!-- Header section -->
    <div class="flex flex-col">
      <div class="flex items-center justify-between">
        <div>
          <h1 class="text-[32px] font-bold mt-6">
            {{ 'publishing.title' | translate }}
          </h1>
          <p class="mb-[30px]">{{ 'publishing.subtitle' | translate }}</p>
        </div>
      </div>
    </div>

    <!-- App info card -->
    @if ((apps$ | async)?.length > 1 || (isAdmin$ | async)) {
      <div
        class="p-6 bg-white rounded shadow-[10px_10px_40px_0px_rgba(255,145,80,0.10)] mb-6 h-[96px] flex items-center justify-between"
      >
        <div class="flex gap-4 items-center">
          <img class="size-12 rounded" [src]="appLogo$ | async" alt="app-log" />
          <h2 class="text-xl font-bold">{{ appName$ | async }}</h2>
          <rk-publishing-header-admin-view></rk-publishing-header-admin-view>
        </div>
        <rk-switch-apps></rk-switch-apps>
      </div>
    }

    <!-- Publishing cards -->
    <div class="flex gap-6 w-full mb-6 publishing-steps flex-1 overflow-hidden">
      <rk-android-publishing-card class="flex-1"></rk-android-publishing-card>

      <rk-ios-publishing-card class="flex-1"></rk-ios-publishing-card>
    </div>

    <!-- Paid publishing banner -->
    <rk-paid-publishing-banner></rk-paid-publishing-banner>
  </div>
}
